module.exports = __webpack_public_path__ + "static/media/side_bar_icon.b431615f.svg";